









import Vue from "vue";

import TheHeader from "@/components/TheHeader.vue";

export default Vue.extend({
  name: "App",

  components: {
    TheHeader
  },
  data: () => ({}),
  async created() {
    this.$root.$on("login", this.login);
    this.$root.$on("logout", this.logout);
    const query = this.$route.query;
    if (query["code"] && query["state"]) {
      // handle the redirect and retrieve tokens
      const result = await this.$auth.handleRedirectCallback();
      // console.log(result);
      await this.login();
      const path = result?.appState?.path ?? this.$route.path;
      this.$router.replace(path);
    } else {
      if (process.env.VUE_APP_AUTO_LOGIN) {
        await this.login();
      }
    }
  },
  methods: {
    async login() {
      await this.$auth.login(this.$route.path);
      Vue.set(this.$root.$data, "user", this.$auth.user);
    },
    async logout() {
      await this.$auth.logout();
      Vue.set(this.$root.$data, "user", null);
    }
  }
});
